/*
 * @format
 */

import { StyleSheet } from 'react-native';

import { accent, black } from '../../colours';

export default StyleSheet.create({
  container: {
    paddingHorizontal: 30,
  },
  // A topic is as tall as the screen even when its content is shorter, so the
  // illustration has room below the copy to be centred in. It still grows past
  // the screen and scrolls when the content is taller than that.
  topicScroll: {
    flexGrow: 1,
  },
  topicContainer: {
    flexGrow: 1,
    paddingHorizontal: 30,
    gap: 24,
  },
  /*
   * Takes the space the copy leaves and centres the illustration in it. Growing
   * only — flexShrink defaults to 0 in React Native — so the slot can never be
   * squeezed smaller than the illustration's own aspect-ratio height; on a
   * screen too short for it, the content grows instead and scrolls.
   */
  diagramSlot: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  // The illustration fills the column; its height comes from the aspect ratio
  // the diagram sets from its own viewBox.
  diagram: {
    width: '100%',
  },
  // The step bar is the app tutorial's Progress bar: the same green tray inset
  // from the screen edge, carrying the count and the controls.
  stepFooter: {
    padding: 16,
  },
  stepFooterBar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: accent(800),
    borderRadius: 8,
    padding: 8,
  },
  // Back and Next are the same width, so the step count stays centred and Next
  // does not move as the label changes to Finish.
  stepButton: {
    minWidth: 96,
    backgroundColor: accent(500),
    borderRadius: 8,
  },
  stepButtonText: {
    color: black,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
});
